export const SHIFT_DISPLAY_MODES = Object.freeze({
  TIME_DEPARTMENT: "time_department",
  TIME_SHIFT: "time_shift",
});

const VALID_SHIFT_DISPLAY_MODES = new Set(Object.values(SHIFT_DISPLAY_MODES));

export function normalizeShiftDisplayMode(value) {
  return VALID_SHIFT_DISPLAY_MODES.has(value) ? value : SHIFT_DISPLAY_MODES.TIME_DEPARTMENT;
}

export function getShiftDisplayParts(value) {
  const mode = normalizeShiftDisplayMode(value);

  return {
    showTime: true,
    showDepartment: mode !== SHIFT_DISPLAY_MODES.TIME_SHIFT,
    showShift: mode !== SHIFT_DISPLAY_MODES.TIME_DEPARTMENT,
  };
}
